(function () {
  function load(image) {
    if (image.dataset.srcset) { image.srcset = image.dataset.srcset; delete image.dataset.srcset; }
    if (image.dataset.src) { image.src = image.dataset.src; delete image.dataset.src; }
  }
  function init() {
    var images = document.querySelectorAll('.hpr__img--secondary[data-src]');
    if (!('IntersectionObserver' in window)) { images.forEach(load); return; }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { load(entry.target); observer.unobserve(entry.target); }
      });
    }, { rootMargin: '200px' });
    images.forEach(function (image) { observer.observe(image); });
    document.querySelectorAll('[data-rail]').forEach(function (rail) {
      new MutationObserver(function (records) {
        records.forEach(function (record) {
          record.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) node.querySelectorAll('.hpr__img--secondary[data-src]').forEach(function (image) { observer.observe(image); });
          });
        });
      }).observe(rail, { childList: true });
    });
  }
  if (window.hadrillRailImagesReady) return;
  window.hadrillRailImagesReady = true;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
